import { render, staticRenderFns } from "./callusForm.vue?vue&type=template&id=132bb902&scoped=true&"
import script from "./callusForm.vue?vue&type=script&lang=js&"
export * from "./callusForm.vue?vue&type=script&lang=js&"
import style0 from "./callusForm.vue?vue&type=style&index=0&id=132bb902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132bb902",
  null
  
)

export default component.exports